export const sendAnalyticsEvent = (event, properties) => {
  try {
    window.amplitude &&
      window.amplitude.getInstance().logEvent(event, properties);
  } catch (err) {
    console.error(err);
  }
};



// WEBPACK FOOTER //
// ./src/app/features/analytics/analytics.services.js